// this is an autogenerated file from App/Account/NewPatient/Content/Panes/Lead/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_NewPatient_Content_Panes_Lead(
  $first_name: String!
  $last_name: String!
  $birth_date: String!
) {
  leads_leads(
    where: {
      first_name: { _ilike: $first_name }
      last_name: { _ilike: $last_name }
      birth_date: { _eq: $birth_date }
      patient_id: { _is_null: true }
    }
  ) {
    id
    first_name
    last_name
    birth_date
  }
}

`